import MetRiportHead, {MetRiportHeadDefaultProps} from "../models/MetRiportHead";
import api from "../services/MetRiportApi";
import dayjs from "dayjs";

import RiportStatus from "../models/RiportStatus";
import MetRiportItem from "../models/MetRiportItem";
import MetRiportExportHead, { MetRiportExportHeadDefaultProps } from "../models/MetRiportExportHead";
import ExportStatus from "../models/ExportStatus";
import MetRiportExportItem from "../models/MetRiportExportItem";

export class MetRiportStore {
    metRiportHead: MetRiportHead = { ...MetRiportHeadDefaultProps};
    metRiportHeads: MetRiportHead[] = [];

    metRiportItems: any;
    notMappedItemsCount = 0;

    metRiportExportHead: MetRiportExportHead = {...MetRiportExportHeadDefaultProps};
    metRiportExportHeads: MetRiportExportHead[] = [];

    riportStatuses: RiportStatus[] = [];
    itemTypes: RiportStatus[] = [];
    exportStatuses: ExportStatus[] = [];

    loading = false;
    showNotMappedCodes = false;
    //---------- Riport ----------//

    async loadMetRiports() { 
        this.metRiportHeads = await api.getMetRiports();
    }

    async removeMetRiport(id: number) { 
        await api.removeMetRiport(id);
    }

    async copyMetRiport(id: number) { 
        await api.copyMetRiport(id);
    }

    //---------- Riport fejléc ----------//

    async loadMetRiportHead(id: number) { 
        this.metRiportHead = await api.getMetRiportHead(id);
    }

    async updateMetRiportHead() {
        this.metRiportHead.id = await api.updateMetRiportHead(this.metRiportHead);
    }

    //---------- Riport tételek ----------//

    async updateMetRiportItem(item: MetRiportItem) { 
        await api.updateMetRiportItem(item);
    }

    async removeMetRiportItem(id: number) { 
        await api.removeMetRiportItem(id);
    }
  
    //---------- Export ----------//

    async removeMetRiportExport(id: number) { 
        await api.removeMetRiportExport(id);
    }

    async closeMetRiportExport(id: number) { 
        await api.closeMetRiportExport(id);
    }

    async exportMetRiportToCSV() { 
        await api.exportMetRiportToCSV(this.metRiportExportHead);
    }

    //---------- Export fejléc ----------//

    async loadMetRiportExportHead(id: number) { 
        this.metRiportExportHead = await api.getMetRiportExportHead(id);
    }

    async updateMetRiportExportHead() { 
        const id: number = await api.updateMetRiportExportHead(this.metRiportExportHead);
        this.metRiportExportHead = await api.getMetRiportExportHead(id)
    }

    //---------- Export tételek ----------//

    async updateMetRiportExportItem(item: MetRiportExportItem) { 
        await api.updateMetRiportExportItem(item);
    }

    async importMetRiportExportItems(id: number, file: File | undefined) { 
        await api.importMetRiportExportItems(id, file);
    }

    async updateMetRiportExportItemsValues() { 
        await api.updateMetRiportExportItemsValues(this.metRiportExportHead);
    }

    //---------- Egyéb ----------//
    async loadRiportStasuses() { 
        this.riportStatuses = await api.getRiportStatuses();
    }

    async loadItemTypes() { 
        this.itemTypes = await api.getItemTypes();
    }

    getItemTypeName(itemType: number): string {
        return this.itemTypes.find((x) => x.id == itemType)?.name ?? "";
    }

    async loadExportStatuses() { 
        this.exportStatuses = await api.getExportStatuses();
    }
    
    getExportStatusName(status: number): string {
        return this.exportStatuses.find((x) => x.id == status)?.name ?? "-";
    }
}

const store = new MetRiportStore();
export default store;